var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookFooterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8554_37847)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8554_37847",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -4,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4 -3.99998H24V24H-4V-3.99998Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8554_37847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.47717 15.5228 1.33514e-05 10 1.33514e-05C4.47716 1.33514e-05 0 4.47717 0 10C0 14.6898 3.2286 18.6249 7.58424 19.7055V13.0558H5.52216V10H7.58424V8.68325C7.58424 5.27957 9.12456 3.70197 12.4662 3.70197C13.0997 3.70197 14.1928 3.82617 14.64 3.95041V6.72057C14.404 6.69573 13.9941 6.68329 13.4848 6.68329C11.845 6.68329 11.2115 7.30441 11.2115 8.91929V10H14.4778L13.9167 13.0558H11.2115V19.9268C16.1629 19.3287 20 15.1127 20 10Z",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.918 13.0558L14.4792 10H11.2128V8.91925C11.2128 7.30437 11.8463 6.68329 13.486 6.68329C13.9954 6.68329 14.4053 6.69569 14.6413 6.72053V3.95041C14.1941 3.82617 13.101 3.70193 12.4674 3.70193C9.12588 3.70193 7.58552 5.27957 7.58552 8.68325V10H5.52344V13.0558H7.58552V19.7055C8.35924 19.8974 9.16824 20 10.0013 20C10.4114 20 10.8156 19.9747 11.2128 19.9268V13.0558H13.918Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8554_37847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFooterLogo);
export default __webpack_public_path__ + "static/media/facebook-footer-logo.e201986c2130914b816d43794c99e176.svg";
export { ForwardRef as ReactComponent };